import React, {useEffect, useState} from 'react';
import PropTypes, {exact} from 'prop-types';


import * as dataUtils from '../../../utils/dataUtils';
import * as styleUtils from '../../../utils/styleUtils';

import usePrevious from '../../hooks/usePrevious';

import {Icon, iconConstants} from '../Icon';

import styles from './Collapsible.scss';


function Collapsible(props) {

    const {entries} = props;

    const initialExpandedEntries = entries.map(({isExpanded}, i) => isExpanded ? i : null)
        .filter(expandedIndex => expandedIndex !== null);

    let [expandedIndexes, setExpandedIndexes] = useState(initialExpandedEntries);

    // edge case 1 - open by default if only 1
    useEffect(() => {

        if (initialExpandedEntries.length === 0 && entries.length > 0) {
            setExpandedIndexes([0]);
        }
    }, []);

    const lastEntries = usePrevious(entries) || entries;

    // edge case 2 - amount increases -> close all and open last
    useEffect(() => {
        if (entries.length > lastEntries.length) {
            setExpandedIndexes([entries.length - 1]);
        }
    }, [entries.length, lastEntries.length, entries.length > lastEntries.length]);

    // edge case 3 - amount decreases and nothing is expanded -> expand last
    useEffect(() => {
        if (entries.length < lastEntries.length) {

            let newExpandedIndexes = expandedIndexes.filter(expandedIndex => !!entries[expandedIndex]);
            if (newExpandedIndexes.length === 0) {
                newExpandedIndexes = [entries.length - 1];
            }
            setExpandedIndexes(newExpandedIndexes);
        }
    }, [entries.length, lastEntries.length, entries.length < lastEntries.length]);

    return (
        <ul
            className={styles.collapsible}
            key={`collapsible-${entries.length}`}
        >

            {entries.map(({actions, content, contentClass, entry, entryClass}, i) => {

                const isExpanded = expandedIndexes.includes(i);

                return (
                    <li key={`collapsible-${entries.length}-${i}`}>
                        <div
                            className={styleUtils.toClasses(styles.entry, props.entryClass, entryClass)}
                            onClick={event => {

                                event.preventDefault();
                                event.stopPropagation();

                                let updatedIndexes = [...expandedIndexes];
                                if (isExpanded) {
                                    updatedIndexes = dataUtils.removeValue(updatedIndexes, i);
                                } else {
                                    updatedIndexes.push(i);
                                }
                                setExpandedIndexes(updatedIndexes);
                            }}
                        >
                            <div className={styles.icon}>
                                <Icon
                                    icon={
                                        isExpanded
                                            ? iconConstants.ICON_MINUS
                                            : iconConstants.ICON_PLUS
                                    }
                                />
                            </div>
                            <div className={styles.value}>{entry}</div>
                            <div className={styles.actions}>{actions}</div>
                        </div>
                        {isExpanded && (
                            <div className={styleUtils.toClasses(styles.content, props.contentClass, contentClass)}>
                                {content}
                            </div>
                        )}
                    </li>
                );
            })}
        </ul>
    );
}


Collapsible.propTypes = {
    contentClass: PropTypes.string,
    entries: PropTypes.arrayOf(
        PropTypes.shape({
            actions: PropTypes.any,
            content: PropTypes.any,
            contentClass: PropTypes.string,
            entry: PropTypes.any,
            entryClass: PropTypes.string,
            isExpanded: PropTypes.bool
        })
    ).isRequired,
    entryClass: PropTypes.string
};


export default Collapsible;
